<!-- Loading Overlay -->
<div *ngIf="isDeactivating" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.7); display: flex; align-items: center; justify-content: center; z-index: 9999;">
  <mat-card style="padding: 32px; text-align: center; border-radius: 12px;">
    <mat-spinner diameter="50" style="margin: 0 auto 16px;"></mat-spinner>
    <h3 style="margin: 0 0 8px 0; font-size: 18px; font-weight: 600;">CoinTypes werden deaktiviert...</h3>
    <p style="margin: 0; color: #666; font-size: 14px;">Bitte warten Sie einen Moment</p>
  </mat-card>
</div>

<app-page-header
  title="Coin-Staffelung verwalten"
  subtitle="Pflege die Wertentwicklung deiner Coins und aktualisiere Staffelungen für neue Zeiträume."
  icon="trending_up"
  [showBackButton]="true"
  variant="gradient">
</app-page-header>

<div class="nlc-container nlc-slide-up">
  <div class="tiering-grid">
    <div class="tiering-card nlc-card">
      <div class="card-header">
        <div class="nlc-icon-visual">
          <mat-icon>calendar_today</mat-icon>
        </div>
        <div>
          <h2 class="nlc-heading-4">Wertänderung auswählen</h2>
          <p class="nlc-caption">Bestimme den Stichtag und bearbeite Coin-Werte.</p>
        </div>
      </div>

      <mat-form-field appearance="outline" class="nlc-field">
        <mat-label>Datum der Wertänderung</mat-label>
        <mat-select (selectionChange)="onCoinTypeChange($event.value)" [value]="selectedCoinTypeId">
          <ng-container *ngIf="coinTypes$ | async as coinTypes">
            <mat-option *ngFor="let coinType of getSortedCoinTypes(coinTypes)" [value]="coinType.id">
              {{ coinType.activeAt | date: 'dd.MM.yyyy' }}
              <span *ngIf="coinType.isActive" style="margin-left: 8px; color: #4CAF50; font-weight: 600;">
                ✓ Aktiv
              </span>
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>

      <div *ngIf="selectedCoinType" class="coin-value nlc-fade-in">
        <div class="coin-info-row">
          <span class="label">Wert pro Coin</span>
          <span class="value">{{ selectedCoinType.value }} €</span>
        </div>
        <div class="coin-info-row">
          <span class="label">Grundbetrag</span>
          <span class="value">{{ selectedCoinType.baseAmount }} Coins / 1000€</span>
        </div>
        <div class="coin-info-row" *ngIf="selectedCoinType.isActive !== undefined">
          <span class="label">Status</span>
          <span class="value" [style.color]="selectedCoinType.isActive ? '#4CAF50' : '#999'">
            {{ selectedCoinType.isActive ? '✓ Aktiv' : '○ Inaktiv' }}
          </span>
        </div>
      </div>

      <div class="tiering-actions">
        <button
          mat-stroked-button
          color="primary"
          class="nlc-button nlc-button-primary"
          style="font-size: 15px; color: white; flex-grow: 1;"
          (click)="openNewCoinTypeDialog()"
        >
          <mat-icon>add_circle</mat-icon>
          Neuen CoinType anlegen
        </button>
        <button
          *ngIf="selectedCoinType"
          mat-stroked-button
          color="accent"
          class="nlc-button nlc-button-primary"
          style="font-size: 15px; color: white; flex-grow: 1;"
          (click)="openEditCoinTypeDialog()"
        >
          <mat-icon>edit</mat-icon>
          CoinType bearbeiten
        </button>
      </div>
    </div>

    <div class="tiering-card nlc-card" *ngIf="selectedCoinType">
      <div class="card-header">
        <div class="nlc-icon-visual">
          <mat-icon>stacked_line_chart</mat-icon>
        </div>
        <div>
          <h2 class="nlc-heading-4">
            Staffelung vom {{ selectedCoinType.activeAt | date: 'dd.MM.yyyy' }}
          </h2>
          <p class="nlc-caption">Staffelwerte für Kundenumsatz und Coin-Anzahl.</p>
        </div>
      </div>

      <div class="table-wrapper">
        <table mat-table [dataSource]="selectedCoinType.tiers" class="nlc-tier-table">
          <ng-container matColumnDef="breakPoint">
            <th mat-header-cell *matHeaderCellDef class="nlc-table-header-cell">Staffelung (ab €)</th>
            <td mat-cell *matCellDef="let tier" class="nlc-table-cell">{{ tier.breakPoint }} €</td>
          </ng-container>

          <ng-container matColumnDef="bonusAmount">
            <th mat-header-cell *matHeaderCellDef class="nlc-table-header-cell">Bonuscoins</th>
            <td mat-cell *matCellDef="let tier" class="nlc-table-cell">{{ tier.bonusAmount }}</td>
          </ng-container>

          <ng-container matColumnDef="coinGain">
            <th mat-header-cell *matHeaderCellDef class="nlc-table-header-cell">Coins pro 1000€</th>
            <td mat-cell *matCellDef="let tier" class="nlc-table-cell">{{ tier.coinGain }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="['breakPoint', 'bonusAmount', 'coinGain']" class="nlc-table-header-row"></tr>
          <tr mat-row *matRowDef="let row; columns: ['breakPoint', 'bonusAmount', 'coinGain']" class="nlc-table-row"></tr>
        </table>
      </div>
    </div>
  </div>
</div>
